/**
 * Formatters - Fiyat, tarih ve diğer veri formatlama fonksiyonları
 */

/**
 * Fiyat formatlar (Türk Lirası)
 * @param {number} value - Fiyat değeri
 * @param {string} currency - Para birimi simgesi (varsayılan: "₺")
 * @returns {string} Formatlanmış fiyat
 */
export const formatPrice = (value, currency = "₺") => {
  try {
    if (value === null || value === undefined) {
      return `${currency}0,00`;
    }
    const numValue = Number(value);
    if (isNaN(numValue)) {
      return `${currency}0,00`;
    }
    return `${currency}${numValue.toLocaleString("tr-TR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  } catch (error) {
    return `${currency}0,00`;
  }
};

/**
 * Tarih formatlar (Türkçe)
 * @param {string|Date} date - Tarih değeri
 * @returns {string} Formatlanmış tarih (gün.ay.yıl)
 */
export const formatDate = (date) => {
  try {
    if (!date) return "-";
    const dateObj = new Date(date);
    if (isNaN(dateObj.getTime())) {
      return "Geçersiz tarih";
    }
    return dateObj.toLocaleDateString("tr-TR");
  } catch (error) {
    return "Geçersiz tarih";
  }
};

/**
 * Tarih ve saat formatlar (Türkçe)
 * @param {string|Date} date - Tarih değeri
 * @returns {string} Formatlanmış tarih ve saat
 */
export const formatDateTime = (date) => {
  try {
    if (!date) return "-";
    const dateObj = new Date(date);
    if (isNaN(dateObj.getTime())) {
      return "Geçersiz tarih";
    }
    return dateObj.toLocaleString("tr-TR");
  } catch (error) {
    return "Geçersiz tarih";
  }
};

/**
 * Toplam fiyat hesaplar
 * @param {number} quantity - Adet
 * @param {number} unitPrice - Birim fiyat
 * @returns {string} Formatlanmış toplam fiyat
 */
export const formatTotalPrice = (quantity, unitPrice) => {
  try {
    const total = (quantity || 0) * (unitPrice || 0);
    return formatPrice(total);
  } catch (error) {
    return formatPrice(0);
  }
};
